import { Link } from "react-router-dom";

export default function PostLink({ text, href }) {

    return (
        <h2 className="post-link">
            <Link to={href}>{text}</Link>
        </h2>
    )
}